import React from 'react';
import {FormattedMessage} from 'react-intl';
import {FormattedDate, FormattedTime} from 'react-intl';

import {
  Table,
  TableBody,
  TableRow,
  TableRowColumn,
  TableHeader,
  TableHeaderColumn
} from 'material-ui/Table';

import ListActionItems from '../../List/ListActionItems';
import AddButton from './../../AddButton';
import LoadMore from '../../LoadMore';
import LoadingSpinner from '../../LoadingSpinner';
import AbstractTableView from '../../common/AbstractTableView';
import LoggedAppBar from '../../LoggedLayout/LoggedAppBar';

class CompetitionsList extends AbstractTableView {
  static propTypes = {
    ...AbstractTableView.propTypes
  };

  confirmRemoveMessage = (
    <FormattedMessage
      id="competition.remove"
      defaultMessage="Are you sure want to delete competition?"
    />
  );

  render() {
    let {list, add, edit, items, hasMore, loading} = this.props;
    let records = list.map(id => items[id]);
    let {palette: {labelColor}, tableHeaderColumn} = this.context.muiTheme;
    let fixedColumn = {style: {width: 120, color: labelColor}};

    return (
      <div>
        <LoggedAppBar title='Competitions' isStatic/>
        <LoadingSpinner show={loading}>
          <LoadMore active={hasMore} loadMore={() => this.loadMore()}>
            <Table selectable={false}>
              <TableHeader adjustForCheckbox={false} displaySelectAll={false} enableSelectAll={false}
                           style={{
                             backgroundColor: tableHeaderColumn.bgColor
                           }}
              >
                <TableRow>
                  <TableHeaderColumn style={{color: labelColor}}>Competition Name</TableHeaderColumn>
                  <TableHeaderColumn style={{color: labelColor}}>Time</TableHeaderColumn>
                  <TableHeaderColumn {...fixedColumn}>Actions</TableHeaderColumn>
                </TableRow>
              </TableHeader>

              <TableBody displayRowCheckbox={false}>
                {records.length > 0
                  ? records.map(({id, name, status, start_time, end_time}) => (
                    <TableRow key={id}>
                      <TableRowColumn>{name}</TableRowColumn>
                      <TableRowColumn>{this.renderTime(start_time, end_time)}</TableRowColumn>

                      <TableRowColumn {...fixedColumn}>
                        <ListActionItems edit={edit}
                                         remove={ this.props.delete }
                                         record={items[id]}
                                         confirmMessageLabel={this.confirmRemoveMessage}
                                         published={['finished'].includes(status)}
                                        //  displayEdit={ ['not_started', 'started'].includes(status) }
                                        //  displayRemove={ ['not_started'].includes(status) }
                        />
                      </TableRowColumn>
                    </TableRow>
                  ))
                  : (<TableRow><TableRowColumn columnNumber={4}>Empty list</TableRowColumn></TableRow>)
                }
              </TableBody>
            </Table>
          </LoadMore>
        </LoadingSpinner>
        <AddButton onClick={add}/>
      </div>
    );
  }

  renderTime(start_time, end_time) {
    return (
      <p>
        <FormattedDate value={start_time}/> <FormattedTime value={start_time}/> - <FormattedDate value={end_time}/> <FormattedTime value={end_time}/>
      </p>
    );
  }
}

export default CompetitionsList;



// WEBPACK FOOTER //
// ./src/components/Competitions/CompetitionsList/CompetitionsList.jsx